import { useState } from "react";

const SIDEBAR_KEY = "prism:sidebar:open";

export function useSidebarPersistence(defaultOpen = true): [boolean, (open: boolean) => void] {
  const [open, setOpen] = useState(() => {
    try {
      const saved = localStorage.getItem(SIDEBAR_KEY);
      return saved !== null ? saved === "true" : defaultOpen;
    } catch {
      return defaultOpen;
    }
  });

  const handleChange = (nextOpen: boolean) => {
    setOpen(nextOpen);
    try {
      localStorage.setItem(SIDEBAR_KEY, String(nextOpen));
    } catch {
      // no-op
    }
  };

  return [open, handleChange];
}
